import dayjs from "dayjs";

export function convertToViewableAmount(amount) {
  const num = parseFloat(amount);

  if (isNaN(num) || num < 0) {
    return "£0.00";
  }

  const formattedAmount = num.toFixed(2);

  return `£${formattedAmount}`;
}

export const formatTime = (timeString) => {
  const [hours, minutes, seconds] = timeString.split(":");
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);
  date.setSeconds(seconds);

  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const commonDateFormat = (date) => {
  return dayjs(date).format("DD/MM/YYYY");
};
